import { addAvatar, deleteAvatar } from "./avatar.action";

export { avatarReducer } from "./avatar.reducer";
export { watchAvatar } from "./avatar.saga";

export const avatarActions = {
  /** Auth Actions */
  addAvatar,
  deleteAvatar,
};
